import { IconCheck } from "@tabler/icons-react";
import { Badge } from "@/components/ui/badge";
import type { Strategy } from "@/mocks/operating-strategy";
import type { useStrategyWizard } from "./use-strategy-wizard";

interface CompleteStepProps {
  created: Strategy;
  wizard: ReturnType<typeof useStrategyWizard>;
}

export function CompleteStep({ created, wizard }: CompleteStepProps) {
  return (
    <section className="flex flex-col gap-6">
      <div className="flex items-center gap-4">
        <span className="flex size-14 items-center justify-center rounded-full border border-success/20 bg-success/10">
          <IconCheck className="size-7 text-success-foreground" stroke={2.5} />
        </span>
        <h2 className="text-xl font-semibold">运营方案已保存</h2>
      </div>
      <div className="flex flex-col gap-5 rounded-[10px] border border-line p-6">
        <div className="flex items-center gap-3">
          <h3 className="text-lg font-semibold">{created.name}</h3>
          <Badge variant="neutral">AI 生成策略</Badge>
        </div>
        <dl className="grid grid-cols-2 gap-5 lg:grid-cols-4">
          {[
            ["商品 ASIN", wizard.asin],
            ["商品阶段", wizard.settings.productStage],
            ["业务目标", created.goal],
            ["执行偏好", wizard.settings.mode],
          ].map(([label, value]) => (
            <div key={label}>
              <dt className="text-xs text-muted-foreground">{label}</dt>
              <dd className="mt-2 text-sm font-medium">{value}</dd>
            </div>
          ))}
        </dl>
      </div>
      <div className="rounded-[10px] border border-line bg-muted/50 p-5">
        <h3 className="text-sm font-semibold">拟定投放结构</h3>
        <ul className="mt-3 flex flex-wrap gap-2">
          {created.campaigns?.map((campaign) => (
            <li key={campaign}>
              <Badge variant="neutral">{campaign}</Badge>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
